import axios from 'axios'
import qs from 'qs'
//import { Loading  } from 'element-ui';
import router from './../../router'
import SEVERS from "@/util/constants.js";
import { Message } from 'element-ui'
import { handleTokenInvalidResponse } from '@/util/auth'
/****** 创建axios实例 ******/
const service = axios.create({
	baseURL: SEVERS.domain,
    timeout: 25000,  // 请求超时时间
});


/****** request拦截器==>对请求参数做处理 ******/

service.interceptors.request.use(config => {
	config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	return config;
}, error => { //请求错误处理
	Promise.reject(error)
});

/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
	response => { //成功请求到数据
//		let loadingInstance = Loading.service();
//		  loadingInstance.close();
		if (handleTokenInvalidResponse(response.data)) {
			return Promise.reject(response)
		}
		//这里根据后端提供的数据进行对应的处理
		// HTML 页或非标准响应没有 code 时不弹错误（保险合同旧 JSONP 列表页仍返回 HTML）
		var biz = response.data;
		if (biz && typeof biz === 'object' && biz.code !== undefined && biz.code !== null) {
			if (biz.code != 0 && biz.code != 200026) {
				if (biz.code == 102003) {
					Message.error('请检查保险公司合同是否到期')
				} else {
					Message.error('错误号：' + biz.code + ',错误信息' + (biz.msg || ''))
				}
			}
		}
			return response;
	},
	error => { //响应错误处理
		return Promise.reject(error)
	}
);
export default service;



// WEBPACK FOOTER //
// ./src/views/axios/request.js